import _ from 'lodash';
import moment from 'moment';
import workloadCoreHelpers from './core/helpers';
import xlsxExport from '../../export/xlsxExport';

export default options => {
  const {
    viewMode, order, workload, scale,
  } = options.data;
  const columns = [];
  const exportOptions = {
    title: options.title,
    worksheets: [],
  };

  columns.push({
    key: 'resourceName',
    label: __('workload_resource_name'),
    type: 'longText',
  });

  _.each(scale.trace_x, (val, i) => {
    const m = moment(val);
    const utcDate = moment(val).utc().add(m.utcOffset(), 'm').toDate();

    columns.push({
      colWidth: 9,
      key: i,
      label: utcDate,
      type: 'numberWithBackground',
    });
  });

  const rows = [];

  _.forEach(order, key => {
    const val = workload[key];

    if (val.unassigned) return;
    if (val.isTasksItem) return;

    const rowData = { resourceName: val.name };

    _.each(val.cellData, (val, i) => {
      const info = val.resourceDayInfo;
      const totalTasksLength = val.totalTasksLength;
      let backgroundHash = '#ffffff';
      let foregroundHash = '#000000';
      let value = 0;

      if (viewMode === 'tasks') {
        value = totalTasksLength;
      } else if (viewMode === 'percents') {
        value = info.totalHours === 0 ? 0 : _.floor((info.totalHours / info.workHours) * 100);

        if (!info.workHours && info.totalHours) {
          value = 100;
        }
      } else {
        value = workloadCoreHelpers.formatNumber(info.totalHours);
      }

      if (info.totalHours === 0) {
        backgroundHash = '#ffffff';
        foregroundHash = '#000000';
      } else if (info.totalHours < info.workHours) {
        backgroundHash = '#f5fff5';
        foregroundHash = '#129534';
      } else if (info.totalHours === info.workHours) {
        backgroundHash = '#cfffe0';
        foregroundHash = '#129534';
      } else if (info.totalHours > info.workHours) {
        backgroundHash = '#ffb3b3';
        foregroundHash = '#B93D30';
      }

      if (info.isWeekend) {
        if (value === 0) value = '';
        backgroundHash = '#F4F8FC';
      }

      rowData[i] = {
        value,
        backgroundHash,
        foregroundHash,
      };
    });

    rows.push({
      attributes: {},
      data: rowData,
    });
  });

  exportOptions.worksheets.push({
    title: exportOptions.title,
    rows,
    columns,
  });

  xlsxExport.export(exportOptions);
};
